import { formatDate, defaultField, isContainedInList } from "helpers/row-logic-helper";
import { get } from "lodash";

const PER_MEASUREMENTS = {
  AT_CLOSE: "abb14a83-6bbf-44e5-8323-a6be5bbc03ab",
  SQUARE_FOOT: "e17e46a3-4685-11e9-82f6-0242ac120002",
  UNIT: "e5166dd1-4685-11e9-82f6-0242ac120002",
  MONTH: "ffcc46d4-4685-11e9-82f6-0242ac120002"
};

export const REPAIR_COMPLETION_DEADLINE = "REPAIR_COMPLETION_DEADLINE";
export const CAPEX_COMPLETION_DEADLINE = "CAPEX_COMPLETION_DEADLINE";

export const shouldShowReplacementPer_Per = data => isContainedInList(data, "replacementPerId", [
  PER_MEASUREMENTS.SQUARE_FOOT,
  PER_MEASUREMENTS.UNIT,
  PER_MEASUREMENTS.MONTH
]);

export const shouldShowRepairPerId_Per = data => isContainedInList(data, "repairPerId", [
  PER_MEASUREMENTS.SQUARE_FOOT,
  PER_MEASUREMENTS.UNIT,
  PER_MEASUREMENTS.MONTH
]);

export const deadlineMapNestedRows = (loan, type) => {
  const items = defaultField(loan, "details");
  if (!items || !items[type] || items[type].length === 0) {
    return [];
  }

  return items[type].reduce((accum, item) => {
    const completed = defaultField(item, "completed");
    accum.push(
      {
        name: defaultField(item, "name"),
        dueDate: `${completed && completed !== "--" ? "Completed," : ""} ${formatDate(defaultField(item, "dueDate"))}`
      }
    );

    return accum;
  }, []);
};

export const shouldShowTaxInsuranceReserve = loan => Boolean(get(loan, "covenants.taxInsuranceReserve"));

export const shouldShowTaxInsuranceReserveAccount = loan => Boolean(get(loan, "covenants.taxInsuranceReserveAccount"));

export const shouldShowReplacementReserve = loan => Boolean(get(loan, "covenants.replacementReserve"));

export const shouldShowReplacementReserveAccount = loan => Boolean(get(loan, "covenants.replacementReserveAccount"));

export const shouldShowRepairReserve = loan => Boolean(get(loan, "covenants.repairReserve"));

export const shouldShowRepairReserveAccount = loan => Boolean(get(loan, "covenants.repairReserveAccount"));

export const shouldShowRepairCompletionDeadline = loan => Boolean(get(loan, "details.repairCompletionDeadline")) && get(loan, "details.repairCompletionDeadline").length > 0;

export const shouldShowTilcReserves = loan => Boolean(get(loan, "covenants.tilcReserves"));

export const shouldShowTilcReservesMisc = loan => Boolean(get(loan, "covenants.tilcReservesMisc"));

export const shouldShowGoodNewsMoneyDrawn = loan => Boolean(get(loan, "covenants.goodNewsMoneyDrawn"));

export const shouldShowFfeReserve = loan => Boolean(get(loan, "covenants.ffeReserve"));

export const shouldShowFfeReserveAccount = loan => Boolean(get(loan, "covenants.ffeReserveAccount"));

export const shouldShowCapExReserves = loan => Boolean(get(loan, "covenants.capExReserves"));

export const shouldShowCapExReservesMisc = loan => Boolean(get(loan, "covenants.capExReservesMisc"));

export const shouldShowCapExCompletionDeadline = loan => Boolean(get(loan, "details.capExCompletionDeadline")) && get(loan, "details.capExCompletionDeadline").length > 0;

export const shouldShowCapExReservesDrawn = loan => Boolean(get(loan, "covenants.capExReservesDrawn"));

export const shouldShowShortfallReserve = loan => Boolean(get(loan, "covenants.shortfallReserve"));

export const shouldShowShortfallReserveMisc = loan => Boolean(get(loan, "covenants.shortfallReserveMisc"));

export const shouldShowOperatingAccount = loan => Boolean(get(loan, "covenants.operatingAccount"));

export const shouldShowInterestRateCapReserve = loan => Boolean(get(loan, "covenants.interestRateCapReserve"));

export const shouldShowInterestRateCapReserveMisc = loan => Boolean(get(loan, "covenants.interestRateCapReserveMisc"));

export const shouldShowInterestReserve = loan => Boolean(get(loan, "covenants.interestReserve"));

export const shouldShowInterestReserveMisc = loan => Boolean(get(loan, "covenants.interestReserveMisc"));

export const shouldShowmInCashDeposit = loan => Boolean(get(loan, "covenants.minCashDeposit"));

export const shouldShowmMiscReserves = loan => Boolean(get(loan, "covenants.escrowAccountsMisc"));
